import { Fade } from "@mui/material";
import React, { Component } from "react";

export default class Delayed extends Component<any, any> {
  static defaultProps = {
    waitBeforeShow: 0,
    fade: false,
  };

  constructor(props: any) {
    super(props);
    this.state = { hidden: true };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ hidden: false });
    }, this.props.waitBeforeShow);
  }

  render() {
    const { children, fade } = this.props;
    const { hidden } = this.state;

    return hidden ? null : fade ? (
      <Fade in={true}>
        <div>{children}</div>
      </Fade>
    ) : (
      children
    );
  }
}
